<template>
  <ui-sheet v-model="model" :title="$t('filters')">
    <template #action>
      <button type="button" class="rm-text-btn" @click="resetDraft">
        {{ $t("report_mobile.reset") }}
      </button>
    </template>
    <div v-if="showRestaurants" class="rm-sheet__group">
      <div class="rm-go-filter-head">
        <h3 class="rm-sheet__label">{{ $t("restaurants") }}</h3>
        <span class="rm-muted rm-num">
          {{ $t("report_mobile.selected_of", { selected: draftIds.length, total: restaurants.length }) }}
        </span>
      </div>
      <div class="rm-go-checks" role="group" :aria-label="$t('restaurants')">
        <label v-for="item in restaurants" :key="item.id" class="rm-go-check">
          <input type="checkbox" :checked="draftIds.includes(item.id)" @change="toggleRestaurant(item.id)" />
          <span>{{ toLatin(item.name) }}</span>
        </label>
      </div>
    </div>

    <div v-if="showDelivery" class="rm-sheet__group">
      <h3 class="rm-sheet__label">{{ $t("delivery_location") }}</h3>
      <div class="rm-filter-wrap">
        <button
          type="button"
          class="rm-chip rm-chip--lg"
          :class="{ 'rm-chip--active': draftDelivery === null }"
          :aria-pressed="String(draftDelivery === null)"
          @click="draftDelivery = null"
        >
          {{ $t("all") }}
        </button>
        <button
          v-for="type in deliveryTypes"
          :key="type.id"
          type="button"
          class="rm-chip rm-chip--lg"
          :class="{ 'rm-chip--active': draftDelivery === type.id }"
          :aria-pressed="String(draftDelivery === type.id)"
          @click="draftDelivery = type.id"
        >
          <v-icon size="18" :color="draftDelivery === type.id ? '#ffffff' : '#1c1917'">{{ type.icon }}</v-icon>
          {{ $t(type.key) }}
        </button>
      </div>
    </div>
    <template #footer>
      <button type="button" class="rm-btn rm-btn--primary rm-go-apply" :disabled="showRestaurants && !draftIds.length" @click="apply">
        {{ $t("report_mobile.apply") }}
      </button>
    </template>
  </ui-sheet>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import { DELIVERY_TYPES } from "@/utils/guestOrderStatus";

/** Filteri izveštaja gostiju na telefonu: restorani (admin) i vrsta isporuke (narudžbe). */
export default {
  name: "GuestMobileFilterSheet",
  mixins: [hasModel],
  props: {
    /** Svi restorani koje admin može da izabere: [{ id, name }] */
    restaurants: { type: Array, default: () => [] },
    selectedIds: { type: Array, default: () => [] },
    showRestaurants: { type: Boolean, default: false },
    showDelivery: { type: Boolean, default: false },
    delivery: { type: Number, default: null },
  },
  data: () => ({
    draftIds: [],
    draftDelivery: null,
    deliveryTypes: DELIVERY_TYPES,
  }),
  watch: {
    value: {
      handler(isOpen) {
        if (isOpen) {
          this.resetDraftToCurrent();
        }
      },
      immediate: true,
    },
  },
  methods: {
    resetDraftToCurrent() {
      this.draftIds = [...this.selectedIds];
      this.draftDelivery = this.delivery;
    },
    /** "Poništi": svi restorani, sve vrste isporuke. */
    resetDraft() {
      this.draftIds = this.restaurants.map((item) => item.id);
      this.draftDelivery = null;
    },
    toggleRestaurant(id) {
      this.draftIds = this.draftIds.includes(id) ? this.draftIds.filter((item) => item !== id) : [...this.draftIds, id];
    },
    apply() {
      this.$emit("apply", { restaurantIds: this.draftIds, delivery: this.draftDelivery });
      this.model = false;
    },
  },
};
</script>
